import React from 'react';
// CSS
import './SyncButton.css';

interface SyncButtonProps {
  onClick: () => void; // クリックイベントのハンドラ
  timeSinceLastClick: string; // 経過時間を表示するためのプロパティ
}

const SyncButton: React.FC<SyncButtonProps> = ({ onClick, timeSinceLastClick }) => {

  const textStyle = {
    color: 'gray',
    fontWeight: 'bold'
  };
  return (
    <div className="sync-container">
      <div className="sync-button-item">
        <button onClick={onClick} className="button-no-style">
          <img src="images/sync.svg" alt="Sync Icon" className="icon myShadow" />
        </button>
      </div>
      <div className="sync-time-item">
        <div style={textStyle}>{timeSinceLastClick ? `${timeSinceLastClick}` : '-'}</div>
      </div>
    </div>
  );
}

export default SyncButton;